<template>
  <div class="main-wrapper" v-if="stable">
    <h3>SS CMS V7</h3>

    <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
      <div class="el-table__body-wrapper is-scrolling-none">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
          <colgroup>
            <col width="180" />
            <col />
          </colgroup>
          <tbody>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>稳定版本</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ stable.version }}</div>
              </td>
            </tr>
            <tr class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>发布时间</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ stable.createdDate }}</div>
              </td>
            </tr>
            <tr v-if="nightly" class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>隔夜版本</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ nightly.version }}</div>
              </td>
            </tr>
            <tr v-if="nightly" class="el-table__row">
              <td rowspan="1" colspan="1">
                <div class="cell">
                  <strong>发布时间</strong>
                </div>
              </td>
              <td rowspan="1" colspan="1">
                <div class="cell">{{ nightly.createdDate }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="el-table__column-resize-proxy" style="display: none"></div>
    </div>

    <div style="height: 10px"></div>

    <el-row>
      <el-button type="primary" plain style="margin-left: 0px" @click="btnAddClick">新 增</el-button>
    </el-row>

    <el-divider></el-divider>

    <h3>所有已发布的版本信息</h3>

    <el-table :data="updates" style="width: 100%">
      <el-table-column width="180" prop="version" label="版本"></el-table-column>
      <el-table-column width="180" prop="createdDate" label="发布日期"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-link
            type="primary"
            :href="`https://dl.sscms.com/cms/${scope.row.version}/sscms-${scope.row.version}-linux-x64.zip`"
            style="margin-right: 5px"
          >
            下载(Linux)
          </el-link>
          <el-link
            type="primary"
            :href="`https://dl.sscms.com/cms/${scope.row.version}/sscms-${scope.row.version}-osx-x64.zip`"
            style="margin-right: 5px"
          >
            下载(MacOs)
          </el-link>
          <el-link
            type="primary"
            :href="`https://dl.sscms.com/cms/${scope.row.version}/sscms-${scope.row.version}-win-x64.zip`"
            style="margin-right: 5px"
          >
            下载(Windows x64)
          </el-link>
          <el-link
            type="primary"
            :href="`https://dl.sscms.com/cms/${scope.row.version}/sscms-${scope.row.version}-win-x86.zip`"
            style="margin-right: 5px"
          >
            下载(Windows x86)
          </el-link>
          <el-link type="danger" @click.prevent="btnDeleteClick(scope.row.id, scope.row.version)" style="margin-right: 5px">
            删 除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IUpdate } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/v7';

interface IState {
  stable?: IUpdate;
  nightly?: IUpdate;
  updates?: IUpdate[];
}

export default defineComponent({
  data() {
    return {
      stable: undefined,
      nightly: undefined,
      updates: undefined,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.stable = res.stable;
        this.nightly = res.nightly;
        this.updates = res.updates;
      });
    },

    apiAdd(version: string) {
      api.add(
        {
          version,
        },
        (res) => {
          this.stable = res.stable;
          this.nightly = res.nightly;
          this.updates = res.updates;
        },
      );
    },

    apiDelete(updateId: number) {
      api.delete(
        {
          updateId,
        },
        (res) => {
          this.stable = res.stable;
          this.nightly = res.nightly;
          this.updates = res.updates;
        },
      );
    },

    btnAddClick() {
      utils.prompt(
        {
          title: '提示',
          message: '请输入版本号',
        },
        (value) => {
          this.apiAdd(value);
        },
      );
    },

    btnDeleteClick(updateId: number, version: string) {
      utils.alertDelete(
        {
          title: `此操作将删除版本 ${version}，确定吗？`,
        },
        () => {
          this.apiDelete(updateId);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
